"use client"
import { useState } from "react";
interface Book {
    title: string;
    image_url: string;
    isbn_13: string;
    asin: string;
    work_urn: string;
    author:string;
  }
interface BookTransitionProps {
    book: Book;
    isActive: boolean;
    isOpen: boolean;
    onOpen: () => void;
    height: number;
    spineColor: string;
    isMobile: boolean
  }

const BookTransition = ({ book, isActive, isOpen, onOpen, height, spineColor, isMobile = false }: BookTransitionProps) => {
    const containerStyles = isActive && !isMobile ? {
    width: '300px',
    height,
    position: isOpen ? 'absolute' : 'relative',
    left: isOpen ? '50%' : 'auto',
  } : {
    width: isMobile ? '172px' : '300px',
    height,
    backgroundColor: spineColor,
  };
  const [imgLoaded, setImgLoaded] = useState(false);

  const imageStyles = {
    width: isMobile ? '172px' : '300px',
    height: '100%',
    opacity: imgLoaded ? 1 : 0 // Control with state
  };

  return (
    <div 
      className={`transition-all duration-1000 ease-in-out ${
        isOpen && !isActive ? '-translate-x-full opacity-0' : 
        isOpen && isActive ? 'absolute -translate-x-0' : 'translate-x-0'
      }`}
      style={{
        width: '300px',
        height,
        backgroundColor: isActive ? 'transparent' : spineColor,
      }}
      onClick={() => isActive && onOpen()}
    >
      {isActive && (
        <img
          src={`https://zilu-cover-images.storage.googleapis.com/${book.isbn_13}.jpg`}
          alt={book.title}
          className="h-full object-cover"
          style={imageStyles}
          draggable="false"
          onLoad={() => setImgLoaded(true)} // This sets the state to true when loaded

        />
      )}
    </div>
  );

 
};

export default BookTransition
